import classNames from "classnames";
import { FC } from "react";

type PropTypes = {
  children: React.ReactNode;
  className?: string;
};

const Card: FC<PropTypes> = ({ children, className }) => {
  return <div className={classNames("card", className)}>{children}</div>;
};

export default Card;
